<template>
  <div>
    <b-row>
      <b-col lg="9">
        <b-form>
          <b-card title="Filtr" class="title-inline h-100">
            <b-card-text>
              <b-form-radio-group
                class="m-2 mb-2 messages-filter"
                v-model="selected"
                :options="filters"
                name="filters"
                plain
              ></b-form-radio-group>
            </b-card-text>
          </b-card>
        </b-form>
      </b-col>
      <b-col lg="3">
        <b-form>
          <b-card title="Wyszukaj" class="title-inline h-100">
            <b-card-text>
              <b-form-input
                class="messages-filter"
                v-model="keyword"
                name="searchbox"
                size="sm"
                plain
              ></b-form-input>
              <b-form-text id="input-live-help"
                >Wpisz szukaną frazę lub datę. <br />Uwaga! Przy dacie zachowaj
                układ RRRR-MM-DD.</b-form-text
              >
            </b-card-text>
          </b-card>
        </b-form>
      </b-col>
    </b-row>
    <div v-if="loading" class="text-center my-3">
      <b-spinner label="Loading..."></b-spinner>
    </div>
    <b-row v-else>
      <b-col lg="12">
        <b-card title="Wiadomości" class="title-inline h-100">
          <div
            class="accordion"
            role="tablist"
            id="m-list"
            :current-page="page"
            v-if="total > 0"
          >
            <b-card
              no-body
              class="my-1"
              v-for="(message, index) in messages"
              :key="message.NR"
            >
              <Message
                :index="index"
                :message="message"
                :program="program"
                :styles="styles"
              ></Message>
            </b-card>
          </div>
          <div v-else>Brak komunikatów</div>
          <b-pagination
            v-if="total > 0"
            v-model="page"
            :total-rows="total"
            :per-page="per_page"
            aria-controls="m-list"
            first-number
            last-number
          ></b-pagination>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Message from './partials/Message';
import { mapGetters } from 'vuex';

export default {
  name: 'Messages',
  components: { Message },
  props: {
    styles: {},
  },
  data() {
    return {
      filters: [
        { text: 'Wszystkie', value: 0 },
        { text: 'Ważne', value: 1 },
        { text: 'Porady dnia', value: 2 },
        { text: 'Aktualności', value: 4 },
        { text: 'Artykuły', value: 5 },
        { text: 'Awarie', value: 6 },
        { text: 'Opieka Serwisowa', value: 7 },
        { text: 'Ostatnie zmiany', value: 8 },
        { text: 'Promocje', value: 9 },
      ],
      selected: 0,
      messages: [],
      allMessages: [],
      page: 1,
      total: null,
      per_page: null,
      keyword: null,
      loading: true,
    };
  },
  computed: {
    ...mapGetters({
      program: 'getProgram',
      licence: 'auth/userLicence',
    }),
  },
  created() {
    this.$store.commit('order/resetOrder');
    this.$store.commit('order/resetSteps');
    this.getMessages();
  },
  methods: {
    getMessages() {
      axios
        .post(
          '/api/getMessages/' +
            this.program +
            '/' +
            this.licence +
            '?page=' +
            this.page,
          {
            type: this.selected,
            keyword: this.keyword,
          }
        )
        .then(({ data }) => {
          this.messages = data.data;
          this.allMessages = data.data;
          this.total = data.total;
          this.per_page = data.per_page;
          this.loading = false;
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 419) {
            this.$store.dispatch('auth/me');
            this.$router.push({ name: 'Login' });
          }
        });
    },
  },
  watch: {
    selected(newValue, oldValue) {
      this.getMessages();
    },
    page(newValue, oldValue) {
      this.getMessages();
    },
    keyword(newValue, oldValue) {
      this.getMessages();
    },
  },
};
</script>

<style scoped></style>
